import { makeAPIRequest } from "../helpers/apiCall";
import { ExplorerCounts } from "../types/explorer";

/**
 * Retrieves counts from the explorer API.
 * @returns {Promise<ExplorerCounts>} A promise resolving to explorer counts.
 */
function getCounts(): Promise<ExplorerCounts> {
  return makeAPIRequest({ url: "/explorer/count", method: "get" })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

export const explorerService = {
  getCounts,
};
